var $d8227b0ec484f402$exports = {};
$d8227b0ec484f402$exports = {
    "replaceMessage": `Drop fil for at erstatte`
};


export {$d8227b0ec484f402$exports as default};
//# sourceMappingURL=da-DK.mjs.map
